import { render, staticRenderFns } from "./UserAddressType.vue?vue&type=template&id=978f69e4&scoped=true&"
import script from "./UserAddressType.vue?vue&type=script&lang=js&"
export * from "./UserAddressType.vue?vue&type=script&lang=js&"
import style0 from "./UserAddressType.vue?vue&type=style&index=0&id=978f69e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978f69e4",
  null
  
)

export default component.exports